{
  "$id": "wealthlane://forms/job-scheduler-recurrence/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "layout": [
    {
      "rowId": "repeat_every",
      "title": "",
      "fields": [
        {
          "type": "stack",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 520,
          "gap": 12,
          "style": {
            "flexDirection": "row",
            "alignItems": "center",
            "alignSelf": "start",
            "paddingBottom": 0
          },
          "stackFields": [
            { "scope": "#/properties/repeatEvery" },
            { "scope": "#/properties/repeatUnit" }
          ]
        }
      ]
    },
    {
      "rowId": "repeat_on",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/repeatOnDays",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 300,
          "maxWidthPx": 520
        }
      ]
    },
    {
      "type": "custom",
      "rowId": "ends",
      "rendererKey": "custom-recurrence-ends"
    }
  ]
}
